<template>
  <div>
    <div class="main">
      <img class="god" :src="content.partner_image_url" />

      <div :class="textContentClass">
        <div :class="textContentTemplate">
          <div class="title" :style="{ color: textContentTitleColor }">
            <span style="white-space: pre-wrap">
              {{ content.activity_name }}
            </span>
          </div>
          <vue-scroll :ops="ops" @handle-resize="handleScrollBarStyle">
            <div class="context" ref="context">
              {{ content.description }}
            </div>
          </vue-scroll>
        </div>
      </div>
      <section style="position: relative;">
        <div v-if="showCountText" class="text">
          <span>{{ content.partner_name }}</span>
          共發出
          <span>{{ content.total_quantity }}</span>
          份{{ content.event_name }} ，目前還剩下
          <span>{{ content.unredeemed_quantity }}</span>
          份。
        </div>
        <div class="input-title">{{ infoText }}</div>
        <div class="input-wrap">
          <input
            class="phone"
            :class="error ? 'error' : ''"
            type="text"
            inputmode="tel"
            :placeholder="placeholderText"
            maxlength="10"
            v-model.trim="phone_number"
            @input="checkCellPhoneNumber"
            @blur="showErrorText"
            oninput="value = value.replace(/[^0-9]/g,'')"
          />
          <div style="height: 4rem;margin: 0.5rem 0;">
            <div class="text-error" v-show="error">
              ＊ 手機格式不正確，請重新輸入
            </div>
          </div>
        </div>
        <div class="agree-label">
          <input type="checkbox" id="agree" v-model="agree" />
          <label for="agree">
            我已詳閱並同意
            <span class="a" @click="goTerms">
              「悠遊卡股份有限公司蒐集處理及利用個人資料告知事項」
            </span>
          </label>
        </div>
        <template v-if="disabled">
          <div
            class="button shadow"
            :style="{ backgroundImage: `url(${btnImg})` }"
            @click="submit"
          ></div>
        </template>
        <template v-else>
          <div
            class="button-disabled shadow"
            :style="{ backgroundImage: `url(${btnDisableImg})` }"
          ></div>
        </template>
        <template v-if="sold_out">
          <img class="mask" src="../assets/image/mask.png" />
          <img class="seal" :src="soldOutImg" />
          <img
            v-show="content.app_display_template === 'PRAYING_CASH'"
            class="word"
            src="../assets/image/soldOutWord.png"
          />
        </template>
      </section>
      <div class="info-text">
        於
        <span>{{ content.expiration_date }}</span>
        前使用
        <br />
        <span>登記手機號碼</span>
        註冊悠遊付會員，才能領取喔!
      </div>
      <div class="dialog" v-if="dialog.opened">
        <div>
          <div class="title">{{ dialogTitle }}</div>
          <div class="content">{{ dialogContent }}</div>
        </div>
        <div class="dialog-btn" @click="handleDialog">確定</div>
      </div>
    </div>
  </div>
</template>

<script>
import vueScroll from 'vuescroll';
import { getEventConfig, checkReserve } from '../utils/api';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'Home',
  components: {
    vueScroll
  },
  data() {
    return {
      dialogTitle: '',
      dialogContent: '',
      is_started: true,
      is_error: false,
      sold_out: false,
      content: {},
      verify: false,
      error: false,
      agree: false,
      phone_number: '',
      ops: {
        scrollPanel: {
          scrollingX: false
        },
        rail: {
          opacity: '1',
          background: 'rgb(241,241,241)',
          size: '1.2rem',
          //keepShow: true,
          specifyBorderRadius: '0'
        },
        bar: {
          background: 'rgb(192,192,192)',
          keepShow: true,
          onlyShowBarOnScroll: false,
          size: '1rem',
          minSize: 0.2
        },
        scrollButton: {
          enable: true,
          background: 'rgb(80,80,80)'
        }
      }
    };
  },
  mounted() {
    this.getContent();
    this.setScrollBar();
  },
  computed: {
    ...mapGetters(['dialog']),
    disabled() {
      return this.agree && this.verify && this.is_started;
    },
    textContentClass() {
      let className;
      switch (this.content.app_display_template) {
        case 'RED_ENVELOPES':
        case 'PRAYING_CASH':
          className = 'padding';
          break;
        case 'CHINESE_VALENTINES':
          className = '';
          break;
      }
      return className;
    },
    textContentTemplate() {
      let className;
      switch (this.content.app_display_template) {
        case 'RED_ENVELOPES':
        case 'PRAYING_CASH':
          className = 'info';
          break;
        case 'CHINESE_VALENTINES':
          className = 'info-img';
          break;
      }
      return className;
    },
    textContentTitleColor() {
      let color;
      switch (this.content.app_display_template) {
        case 'RED_ENVELOPES':
        case 'PRAYING_CASH':
          color = 'rgb(241, 37, 26)';
          break;
        case 'CHINESE_VALENTINES':
          color = 'rgb(255, 255, 255)';
          break;
      }
      return color;
    },
    infoText() {
      let text;
      switch (this.content.app_display_template) {
        case 'RED_ENVELOPES':
          text = '登記手機號碼搶紅包';
          break;
        case 'PRAYING_CASH':
          text = '登記手機號碼搶結緣金';
          break;
        case 'CHINESE_VALENTINES':
          text = '登記手機號碼立搶姻緣金';
          break;
      }
      return text;
    },
    placeholderText() {
      let text;
      switch (this.content.app_display_template) {
        case 'RED_ENVELOPES':
          text = '請輸入手機號碼保留紅包';
          break;
        case 'PRAYING_CASH':
          text = '請輸入手機號碼保留結緣金';
          break;
        case 'CHINESE_VALENTINES':
          text = '請輸入手機號碼保留姻緣金';
          break;
      }
      return text;
    },
    btnImg() {
      let img;
      switch (this.content.app_display_template) {
        case 'RED_ENVELOPES':
        case 'PRAYING_CASH':
          img = require('../assets/image/btnBtnSend.png');
          break;
        case 'CHINESE_VALENTINES':
          img = require('../assets/image/btnCVdayBtnSend.png');
          break;
      }
      return img;
    },
    btnDisableImg() {
      let img, soldOutImg, uninitiatedImg;
      switch (this.content.app_display_template) {
        case 'RED_ENVELOPES':
          img = require('../assets/image/btnBtnEventClose.png');
          soldOutImg = require('../assets/image/btnBtnSendDisable.png');
          uninitiatedImg = require('../assets/image/btnBtnEventUninitiated.png');
          break;
        case 'PRAYING_CASH':
          img = require('../assets/image/btnBtnEventCloseGod.png');
          soldOutImg = require('../assets/image/btnBtnSendDisable.png');
          uninitiatedImg = require('../assets/image/btnBtnEventUninitiated.png');
          break;
        case 'CHINESE_VALENTINES':
          img = require('../assets/image/btnCVdayBtnEventClose.png');
          soldOutImg = require('../assets/image/btnCVdayBtnSendDisable.png');
          uninitiatedImg = require('../assets/image/btnCVdayBtnEventUninitiated.png');
          break;
      }

      if (this.sold_out) {
        return img;
      } else if (!this.is_started) {
        return uninitiatedImg;
      } else {
        return soldOutImg;
      }
    },
    soldOutImg() {
      let img;
      switch (this.content.app_display_template) {
        case 'RED_ENVELOPES':
          img = require('../assets/image/soldOut.png');
          break;
        case 'PRAYING_CASH':
          img = require('../assets/image/soldOutGod.png');
          break;
        case 'CHINESE_VALENTINES':
          img = require('../assets/image/CVdaySoldOut.png');
          break;
      }
      return img;
    },
    showCountText() {
      if (this.content.praying_cash_type === 'RED_ENVELOPES') {
        return false;
      } else if (
        this.content.praying_cash_type === 'PRAYING_CASH' &&
        this.content.is_ended &&
        this.content.unredeemed_quantity !== 0
      ) {
        return false;
      } else {
        return true;
      }
    }
  },
  methods: {
    ...mapActions(['formatPhoneNumber', 'formatDateTime', 'toggleDialog']),
    async getContent() {
      await getEventConfig().then(res => {
        if (!res.error) {
          this.error = false;
          this.content = res;
          this.content.expiration_date = this.formatDate(res.expiration_date);
          if (res.is_started) {
            this.is_started = true;
            if (this.content.is_ended) {
              this.sold_out = true;
              this.toggleDialog(true);
              this.dialogTitle = '真可惜，活動已經結束了';
            }
            this.sold_out = this.content.is_sold_out;
          } else {
            this.is_started = false;
            this.toggleDialog(true);
            this.dialogTitle = '活動尚未開始';
          }
          this.setDialogContent(res.is_started);
        } else {
          this.content.app_display_template = 'PRAYING_CASH';
          this.is_error = true;
          this.toggleDialog(true);
          this.dialogTitle = res.error.message;
        }
      });
      this.handleScrollBarStyle();
    },
    setDialogContent(is_started) {
      if (is_started) {
        switch (this.content.app_display_template) {
          case 'RED_ENVELOPES':
          case 'PRAYING_CASH':
            return (this.dialogContent = '感謝您的參與，祝您牛轉乾坤');
          case 'CHINESE_VALENTINES':
            return (this.dialogContent = '感謝您的參與，祝您心心相印');
        }
      } else {
        return (this.dialogContent = `活動將於 ${this.formatDate(
          this.content.effective_date
        )} 開始`);
      }
    },
    setScrollBar() {
      let scrollv = document.getElementsByClassName('__vuescroll')[0];
      scrollv.style.marginTop = '1.5rem';
      scrollv.style.overflow = 'unset';
    },
    handleScrollBarStyle() {
      this.$nextTick(() => {
        let scrollBar = document.getElementsByClassName(
          '__rail-is-vertical'
        )[0];
        let contentWidth = this.$refs.context.clientWidth + 5;
        if (scrollBar) {
          scrollBar.style.left = `${contentWidth}px`;
        }
      });
    },
    formatDate(dateTime) {
      let Y = dateTime.substring(0, 4) + '/';
      let M = dateTime.substring(4, 6) + '/';
      let D = dateTime.substring(6, 8) + ' ';
      let h = dateTime.substring(8, 10) + ':';
      let m = dateTime.substring(10, 12) + ':';
      let s = dateTime.substring(12);

      return Y + M + D + h + m + s;
    },
    checkCellPhoneNumber() {
      let mobileReg = /^09[0-9]{8}$/;
      this.verify = mobileReg.test(this.phone_number);
    },
    showErrorText() {
      if (this.phone_number === '') {
        this.error = false;
      } else {
        this.error = !this.verify;
      }
    },
    async submit() {
      await window.grecaptcha
        .execute(sessionStorage.getItem('recaptchaKey'), {
          action: 'submit'
        })
        .then(function(token) {
          sessionStorage.setItem('recaptchaToken', token);
          console.log('token', token);
        });
      checkReserve(this.phone_number).then(res => {
        if (!res.error) {
          let reserveStatus = res.reserve_status;

          switch (reserveStatus) {
            case 'DUPLICATED':
            case 'RESERVED':
              this.formatPhoneNumber(this.phone_number);
              this.formatDateTime(res.expiration_date);
              this.$router.push({
                path: '/finish',
                query: {
                  t: this.content.app_display_template,
                  s: 'RESERVED',
                  c: sessionStorage.getItem('cfc')
                }
              });
              break;
            case 'REGISTERED':
              this.$router.push({
                path: '/finish',
                query: {
                  t: this.content.app_display_template,
                  s: 'FINISHED',
                  c: sessionStorage.getItem('cfc')
                }
              });
              break;
          }
        } else {
          this.is_error = true;
          this.toggleDialog(true);
          this.dialogTitle = res.error.message;
        }
      });
    },
    handleDialog() {
      this.toggleDialog(false);
      if (this.is_error) {
        window.location.href =
          'https://easywallet.easycard.com.tw/benefit/?page=1';
      }
    },
    goTerms() {
      window.open(`https://lihi1.com/g9akI`);
    }
  }
};
</script>
